import { PathHelper } from "./PathHelper";
import { StringHelper } from "./StringHelper";
import { NAMESPACE } from "./_Namespace";

export class CookieHelper
{
    public static classNamespace = NAMESPACE + "CookieHelper";
    public static className = "CookieHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Public Methods

    public static create(name: string, value: string, days?: number)
    {
        const
            location = PathHelper.getLocation(window.location);
            
        let
            expires = StringHelper.empty;

        if (days)
        {
            const
                date = new Date();

            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

            expires = "; expires=" + date.toUTCString();
        }

        let
            cookie = name + "=" + value + expires + "; path=/";

        if (location.protocol === "https:")
            cookie += "; secure";

        document.cookie = cookie;
    }
    public static delete(name: string)
    {
        this.create(name, StringHelper.empty, -1);
    }
    public static read(name: string)
    {
        const
            nameEQ = name + "=",
            ca = document.cookie.split(";");

        for (let i = 0; i < ca.length; i++)
        {
            let
                c = ca[i];

            while (c[0] === " ")
                c = c.substring(1, c.length);

            if (c.indexOf(nameEQ) === 0)
                return c.substring(nameEQ.length, c.length);
        }

        return null;
    }

    // #endregion
}